module.exports = __webpack_public_path__ + "static/media/cat-is-wrong.e70b9487.mp3";